import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

// select real estates keyed by id
export const selectRealEstatesData = createSelector(
  [(state: ApplicationState) => state.RealEstateStore.data],
  (data) => data
)

export const selectRealEstatesFetched = createSelector(
  [(state: ApplicationState) => state.RealEstateStore.fetched],
  (fetched) => fetched
)
